enum InputDataType {
  string = "string",
  number = "number",
  email = "email",
  phone = "phone",
  boolean = "boolean",
  date = "date",
  iban = "iban",
  array = "array",
}

export default InputDataType;
